import { apiClient } from '@/lib/api';
import type { CapacitySlot, LeaveBlock, ResourceAvailability } from '@skewb-works/contracts';

const BASE = '/works-lite/planner';

export const availabilityService = {
  /**
   * Get approved leave blocks for resources in date range
   */
  async getAvailability(start: string, end: string, userIds?: number[]): Promise<LeaveBlock[]> {
    const params = new URLSearchParams({ start, end });
    if (userIds && userIds.length > 0) {
      params.set('userIds', userIds.join(','));
    }
    return apiClient.get<LeaveBlock[]>(`${BASE}/availability?${params}`);
  },

  /**
   * Get capacity utilization per user per day
   */
  async getCapacity(start: string, end: string, userIds?: number[]): Promise<CapacitySlot[]> {
    const params = new URLSearchParams({ start, end });
    if (userIds && userIds.length > 0) {
      params.set('userIds', userIds.join(','));
    }
    return apiClient.get<CapacitySlot[]>(`${BASE}/capacity?${params}`);
  },

  /**
   * Get combined resource availability (capacity + leave) per user
   */
  async getResourceAvailability(
    start: string,
    end: string,
    userIds?: number[],
  ): Promise<ResourceAvailability[]> {
    const params = new URLSearchParams({ start, end });
    if (userIds && userIds.length > 0) {
      params.set('userIds', userIds.join(','));
    }
    return apiClient.get<ResourceAvailability[]>(`${BASE}/resource-availability?${params}`);
  },
};
